export default {
  donate: 'You Search We Donate',
  makeMore: 'make {count} more searches to help an animal.',
  promotional:
    'When you make Cheerie your new search engine, a donation from every search goes to saving dogs and cats in need. And, even better, it’s 100% free for you.',
  searchPrompt: 'Search to save animals...',
  mealsOffered: 'meals offered to animals in shelters by Cheerie',
  charitiesWeSponsored: "Charities we've sponsored so far.",
  howToTitle: 'How It Works',
  howToTitle01: 'How It Works',
  howToDescription01:
    'Every time you make a search with Cheerie, you are making a small donation.',
  howToTitle02: 'How It Works',
  howToDescription02:
    'Cheerie is ad sponsored, which means its totally free for you to use.',
  howToTitle03: 'How It Works',
  howToDescription03:
    'Your searches support no kill animal rescue shelters such as Best Friends.',
  bubble1: {
    title: 'Free For You',
    text: 'Donating a portion of our profits means you can make a difference every single day. With something as simple as an internet search.',
  },
  bubble2: {
    title: 'Transparent Donations',
    text: 'Our openly available reports show you exactly where the money from your searches is helping.',
  },
  bubble3: {
    title: 'Safe To Use',
    text: 'All your data is encrypted. Our tech whizzes are dedicated to giving you the best search experience possible.',
  },
  action: 'Get Cheerie Now',
  faqTitle: 'Frequently Asked Questions',
  faqs: {
    faq1: {
      question: 'What is Cheerie?',
      answer:
        'Cheerie is a search engine that is dedicated to saving animals in need with the help of our charity partners.',
    },
    faq2: {
      question: 'How donations are generated?',
      answer:
        'We are completely ad sponsored so every time an ad is clicked, we donate a portion of the revenue to a rescue shelter.',
    },
    faq3: {
      question: 'Who are Best Friends?',
      answer:
        "Best Friends is an animal rescue shelter with the aim to make every single shelter in America 'no-kill' by 2025.",
    },
    faq4: {
      question: 'Is it free for all?',
      answer: 'Yes! It is completely free to use.',
    },
  },
};
